<template>
  <div>
    <q-card style="padding: 15px" v-if="items.length === 0 && !isLoading">
      <empty-value name="vehicle"></empty-value>
    </q-card>

    <div class="content-table" ref="table" v-else>
      <div v-if="items.length > 0">
        <q-btn
          v-if="items.length > 0"
          class="glossy custom-item-icon-3 left-0"
          style="margin-left: -10px"
          @mousedown="shiftLeft()"
          @mouseup="shiftLeftEnd()"
          round
          color="primary"
          icon="fas fa-arrow-left"
        />
        <q-btn
          v-if="items.length > 0"
          class="glossy custom-item-icon-3 right-0"
          @mouseup="shiftRightEnd()"
          @mousedown="shiftRight()"
          round
          color="primary"
          icon="fas fa-arrow-right"
        />
        <table>
          <thead>
          <tr>
            <th v-for="column in columns">{{ column.name }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item.id">
            <td v-for="column in columns" v-if="column.visible">
              <div v-if="column.val === 'selection'">
                <q-btn round size="sm"
                             :color="selectedHistoryItems.some(i => i.vehicle.vin === item.vehicle.vin) ? 'green' : 'grey'"
                             @click.native="toggleSelectedItem(item)">
                  <template v-slot:default>
                    <q-icon name="fas fa-check" v-if="selectedHistoryItems.some(i => i.vehicle.vin === item.vehicle.vin)"/>
                  </template>
                </q-btn>
              </div>
              <div v-else-if="column.val === 'unit'">{{ item.vehicle.unit }}</div>
              <div v-else-if="column.val === 'result'">
                <q-badge :color="item.result === 'failed' ? 'red' : 'green'">
                  {{ item.result.toUpperCase() }}
                  <q-tooltip>
                    <div>{{ item.message }}</div>
                  </q-tooltip>
                </q-badge>
              </div>
              <div v-else-if="column.val === 'provider'">{{ getSellProvider(item.provider) }}</div>
              <div v-else-if="column.val === 'vin'">{{ item.vehicle.vin }}</div>
              <div v-else-if="column.val === 'company'">{{ item.vehicle.company.name }}</div>
              <div v-else-if="column.val === 'location'">{{ item.vehicle.location.code }}</div>
              <div v-else-if="column.val === 'group'">{{ item.vehicle.group_name }}</div>
              <div v-else-if="column.val === 'class'">{{ item.vehicle.class_name }}</div>
              <div v-else-if="column.val === 'make'">{{ item.vehicle.brand.name }}</div>
              <div v-else-if="column.val === 'model'">{{ item.vehicle.model.name }}</div>
              <div v-else-if="column.val === 'model_detail'">{{ item.vehicle.model_detail.name }}</div>
              <div v-else-if="column.val === 'model_year'">{{ item.vehicle.model_year }}</div>
              <div v-else-if="column.val === 'mileage'">{{ item.mileage }}</div>
              <div v-else-if="column.val === 'color'">{{ item.vehicle.color }}</div>
              <div v-else-if="column.val === 'due_location_name'">{{ item.due_location_name }}</div>
              <div v-else-if="column.val === 'pickup_location_number'">{{ item.pickup_location_number }}</div>
              <div v-else-if="column.val === 'price'">{{ getUsdValue(item.price) }}</div>
              <div v-else-if="column.val === 'grade'">{{ item.grade ?? '-' }}</div>
              <div v-else-if="column.val === 'initial_cost'">{{ item.initial_cost ? getUsdValue(item.initial_cost) : '-' }}</div>
              <div v-else-if="column.val === 'retail'">{{ item.retail ? 'Yes' : 'No' }}</div>
              <div v-else-if="column.val === 'wholesale'">{{ item.wholesale ? 'Yes' : 'No' }}</div>
              <div v-else-if="column.val === 'is_with_mmr'">{{ item.is_with_mmr ? 'Yes' : 'No' }}</div>
              <div v-else>{{ item[column.val] }}</div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="loading-infinite" v-if="isLoading">
        <div>
          <q-spinner-facebook color="primary" size="40px"/>
          <div class="text-grey-7">Loading</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import {VMoney} from "v-money";
import EmptyValue from "@/components/EmptyValue.vue";
import {getSellProvider} from "@/enums";

export default {
  name: 'History',
  components: {EmptyValue},
  props: {
  },
  data() {
    return {
      isLoading: true,
      companies: [],
      columns: [],
      results: [
        {
          label: 'Success',
          value: 'success'
        },
        {
          label: 'Failed',
          value: 'failed'
        }
      ],
      per: 100,
      page: 1,
      lastPage: 1,
      items: [],
    }
  },
  computed: {
    historyListColumns: {
      get() {
        return this.$store.state.forSale.historyListColumns;
      },
      set(val) {
        this.$store.commit("forSale/SET_HISTORY_LIST_COLUMNS", val);
      },
    },
    historyFilter: {
      get() {
        return this.$store.state.forSale.historyFilter;
      },
      set(val) {
        this.$store.commit("forSale/SET_HISTORY_FILTER", val);
      },
    },
    selectedHistoryItems: {
      get() {
        return this.$store.state.forSale.selectedHistoryItems;
      },
      set(val) {
        this.$store.commit("forSale/SET_SELECTED_HISTORY_ITEMS", val);
      },
    },
  },
  async mounted() {
    const el = document.querySelector('.scroll-content')
    setTimeout(() => {
      el.addEventListener('scroll', this.onScroll)
    }, 1000)
    this.selectedHistoryItems = []
    await this.getItems()
  },
  destroyed() {
    const el = document.querySelector('.scroll-content')
    el.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    getSellProvider,
    shiftRight() {
      this.rightInterval = setInterval(() => {
        this.$refs.table.scrollLeft += 50
      }, 50)
    },
    shiftRightEnd() {
      clearInterval(this.rightInterval)
    },
    shiftLeft() {
      this.leftInterval = setInterval(() => {
        this.$refs.table.scrollLeft -= 50
      }, 50)
    },
    shiftLeftEnd() {
      clearInterval(this.leftInterval)
    },
    async getItems() {
      const params = {
        per: this.per,
        page: this.page,
      }
      if (this.historyFilter.company !== null) {
        params.company_id = this.historyFilter.company
      }
      if (this.historyFilter.result !== null) {
        params.result = this.historyFilter.result
      }
      if (this.historyFilter.keyword !== '') {
        params.q = this.historyFilter.keyword
      }

      this.isLoading = true
      const {data} = await axios.get('/sell/history', {params})
      this.lastPage = data.data.pagination.last

      let deep = () => {
        if (this.page === 1) {
          return data.data.items.map(item => item)
        } else {
          let carbon = [...this.items]
          let nextPage = data.data.items.map(item => item)
          return carbon.concat(nextPage)
        }
      }
      this.items = deep()
      this.isLoading = false
    },
    async onScroll(e) {
      const obj = e.target
      if (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight && this.items.length !== 0 &&
        !this.isLoading && this.page < this.lastPage) {
        this.page++
        await this.getItems()
      }
    },
    toggleSelectedItem(item) {
      const index = this.selectedHistoryItems.findIndex(vehicle => vehicle.vehicle.vin === item.vehicle.vin)
      if (index === -1) {
        this.selectedHistoryItems.push(item)
      } else {
        this.selectedHistoryItems.splice(index, 1)
      }
    },
    getUsdValue(value) {
      return value?.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      })
    },
  },
  watch: {
    historyListColumns: {
      deep: true,
      immediate: true,
      handler(columns) {
        this.columns = columns.filter(col => col.visible)
      }
    },
    historyFilter: {
      deep: true,
      immediate: true,
      async handler(val) {
        if (val.changed) {
          val.changed = false
          this.page = 1
          this.items = []
          await this.getItems()
        }
      }
    },
    isSellVehicles: {
      deep: true,
      immediate: true,
      async handler(val) {
        if (val) {
          this.isSellVehicles = false
          const valid = await this.$refs.postSellVehiclesFormRef.validate()
          if (valid) {
            await this.postSellVehicles()
          }
        }
      }
    },
  },
  directives: {money: VMoney},
}
</script>

<style scoped lang="scss">
.custom-item-icon-3 {
  z-index: 999 !important;
  position: fixed !important;
  top: 60% !important;
}
.right-0 {
  right: 0;
}
.table-cell {
  display: table-cell;
}
.none-cell {
  display: none;
}
.selected-finance {
  background: rgba(244, 67, 54, 0.5) !important;
}
.no-finance {
  background: rgba(244, 67, 54, 0.1) !important;
}
.tag-table-container {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  .tag-item {
    margin-right: -5px;
    height: 30px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    border-radius: 50%;
  }
}
.mark-table {
  background: rgba(0, 0, 0, 0.12) !important;
}
.flip-list-move {
  transition: transform 500ms;
}
.content-table {
  position: relative;
  z-index: 1;
  overflow: auto;
}
.content-table table {
  min-width: auto !important;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}
.table-wrap {
  position: relative;
}
.content-table {
  th {
    align-items: center;
    padding: 15px 5px;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    vertical-align: center;
    text-align: center;
  }
  td {
    padding: 15px 10px;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    vertical-align: center;
    text-align: center;
    cursor: auto;
  }
}
@media only screen and (max-width: 600px) {
  .content-table th,
  .content-table td {
    padding: 15px 5px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    vertical-align: center;
    text-align: left;
  }
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.container-checkbox {
  width: 18px;
  cursor: pointer;
  height: 18px;
  text-align: center;
  border: 2px solid rgba(0, 0, 0, 0.54);
}
.input-col {
  padding: 30px 10px 10px !important;
}
.fix-col {
  min-width: 100px;
}
.fix-col-lg {
  min-width: 130px;
}
.fix-col-xl {
  min-width: 170px;
}
</style>
